/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { createContext, useEffect, useState, useContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_All_THEMES } from '../queries'
import Loading from "../screens/loading";
import routes from '../config/routes.js';

export const ThemeDataContext = createContext(null)

export function useThemeData() {
    return useContext(ThemeDataContext);
}

export function ThemeDataProvider ({ children }) {
  const [themeData, setThemeData] = useState(null)
  const [domain_name] = useState(window.location.host)
  const fotograaf_id = localStorage.hasOwnProperty('photographer_id') ? localStorage.getItem('photographer_id') !== 'null' ? localStorage.getItem('photographer_id') : null : null
  const [photographerType, setPhotographerType] = useState(null);
  const [category_id, setCategoryID] = useState(0);
  const categoryData = {category_id: category_id, setCategoryID: setCategoryID};
  const [newRoute, setNewRoute] = useState(routes.loading)

  let width = document.documentElement.clientWidth;
  let screenWidth = localStorage.getItem('screen-width');

  const { loading: loadingTheme, error: errorTheme, data: dataTheme } =
    useQuery(GET_All_THEMES, {
      fetchPolicy: 'cache-first',
      variables: {
        domain_name: domain_name,
        fotograaf_id: fotograaf_id
      },
      skip: !domain_name,
      onError (...error) {
        //hier moeten meldingen komen
      }
    });

  useEffect(() => {
    if (!loadingTheme && !errorTheme) {
      if (dataTheme) {
        setThemeData(dataTheme);
        document.title = dataTheme.site.title;
        if (dataTheme.site.siteconfig.type === 'schoolphotographer') {
            setPhotographerType('schoolfotos')
        } else {
            setPhotographerType(dataTheme.site.siteconfig.type)
        }
          setCategoryID(dataTheme.site.first_category_ID);
      }
    }
  }, [dataTheme, loadingTheme, errorTheme]);

  useEffect(() => {
    switch (photographerType) {
      case 'printservice':
        setNewRoute(routes.printservice);
        break;
      case 'equestrianphotoservice':
        setNewRoute(routes.equestrianphotoservice);
        break;
      case 'schoolfotos':
        setNewRoute(routes.schoolphotographer);
        break;
      case 'professionalphotographer':
        setNewRoute(routes.photoservice);
        break;
      default: //loading
        setNewRoute(routes.loading);
        break;
      }
}, [photographerType])

  useEffect(() => {
    if (width !== screenWidth) {
        localStorage.setItem('screen-width', width)
    }
  }, [width, screenWidth])

  if (loadingTheme || dataTheme === null) return <Loading/>
  if (errorTheme) return <p>{'Looks like we have a problem...'}</p>
  if (!themeData || !photographerType) return null;

  const create_account = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'create_account') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'create_account').option_value : false
  const bijsnijden_fotos = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'bijsnijden_fotos') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'bijsnijden_fotos').option_value : false
  const oudste_kind_klas = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'klas_oudste_kind_keuze') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'klas_oudste_kind_keuze').option_value : true
  const kind_klas = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'klas_kind_keuze') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'klas_kind_keuze').option_value : true
  const upload_photos = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'upload_photos') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'upload_photos').option_value : false
  const navigation = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'navigation') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'navigation').option_value : true
  const videos_active = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'videos_active') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'videos_active').option_value : false
  const contact_footer = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'contact_footer') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'contact_footer').option_value : false
  const kassakoopjes = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'kassakoopjes') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'kassakoopjes').option_value : false
  const shippingcost_free_period = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'shippingcost_free_period') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'shippingcost_free_period').option_value : true
  const share_photos_facebook = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'share_photos_facebook') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'share_photos_facebook').option_value : false
  const newsletter = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'newsletter') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'newsletter').option_value : false
  const hide_photo_overview = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'hide_photo_overview') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'hide_photo_overview').option_value : false
  const hide_category_side_bar = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'hide_category_side_bar') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'hide_category_side_bar').option_value : false
  const greenscreen_background_required = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'greenscreen_background_required') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'greenscreen_background_required').option_value : false
  const greenscreen_default_background = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'greenscreen_default_background') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'greenscreen_default_background').option_value : false
  const alert_popup = themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'alert_popup') ? themeData.site.siteoptions.find(s => s.option_type === 'others' && s.option_name === 'alert_popup').option_value : false

  const modules = {
    create_account,
    bijsnijden_fotos,
    oudste_kind_klas,
    kind_klas,
    upload_photos,
    navigation,
    videos_active,
    contact_footer,
    kassakoopjes,
    shippingcost_free_period,
    share_photos_facebook,
    newsletter,
    hide_photo_overview,
    hide_category_side_bar,
    greenscreen_background_required,
    greenscreen_default_background,
    alert_popup
  }

  document.getElementById("body").style = `background-color: ${themeData.site.theme ? themeData.site.theme.background_color_6 : '#fff'};`;

  const WebFont = require('webfontloader');
  WebFont.load({
    google: {
      families: [themeData.site.theme.font_family, themeData.site.theme.font_family_title, themeData.site.theme.font_family_link, themeData.site.theme.font_family_button]
    }
  });

  return (
    <ThemeDataContext.Provider value={{
      themeData,
      newRoute,
      modules,
      photographerType,
      categoryData
    }}>
      {children}
    </ThemeDataContext.Provider>
  )
}
